/**
 * @generated SignedSource<<bc980efc5ff5e635370f791663aa19ff>>
 * @relayHash 7a91c4e9dc9c3329f704e5dcb8466252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b55f90f67c621690126b363fafb511f6570df98f56e57cf7dcc787d6df9e513

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8b55f90f67c621690126b363fafb511f6570df98f56e57cf7dcc787d6df9e513",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
